module.exports = __webpack_public_path__ + "img/selected4-min.d1b2e7c4.png";